import { Router, RouterModule } from '@angular/router';
import { Component, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AdminService } from 'src/app/services/admin/admin.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { HeaderAuthComponent } from 'src/app/components/layout/header-auth/header-auth.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-reset-pass',
  standalone: true,
  imports: [
    HeaderAuthComponent,
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule
  ],
  templateUrl: './reset-pass.component.html',
  styleUrls: ['./reset-pass.component.css']
})
export class ResetPassComponent implements OnInit {
  validateForm!: FormGroup;
  load = false
  error: string = '';
  selectedLanguage: string = '';

  constructor(
    private fb: FormBuilder,
    public admin: AdminService,
    private router: Router,
    private ToastrService: ToastrService,
    private translateService: TranslateService,
    private languageService: LanguagesService,
    
    ) {
      this.languageService.selectedLanguage$.subscribe(
        (lang: any) => {this.selectedLanguage = lang?.code}
      );
  }

  ngOnInit(): void {
    if(this.admin.isAdmin()){
      this.router.navigate([''])
    }
    this.validateForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
    });
  }


  submitForm(){

    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls.hasOwnProperty(i)) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }

    const data = {
      email:  this.validateForm.value.email,
      lang: this.selectedLanguage
    }

    if(!this.admin.isAdmin()){
      this.load = true
      this.admin.resetPassword(data).subscribe(
        (res: any) => {
          // console.log(res)
          this.load = false
          this.ToastrService.success(this.translateService.instant('PASSWORD_RESET_SENT'))
          this.validateForm.get('email').reset()
        },
        (error: any) => {
          console.log(error)
          this.load = false
          this.ToastrService.error(this.translateService.instant('PASSWORD_RESET_ERROR'))
          // console.log('შეცდომა: ' ,error)  
        }
      )
    }
  }



}
